import { render, staticRenderFns } from "./PositionAssignmentsTable.vue?vue&type=template&id=1dfbed15&scoped=true"
import script from "./PositionAssignmentsTable.vue?vue&type=script&lang=js"
export * from "./PositionAssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./PositionAssignmentsTable.vue?vue&type=style&index=0&id=1dfbed15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbed15",
  null
  
)

export default component.exports